// test2087
(2087 && 0);
